module.exports = new __parcel__URL__("authenticate-confluence.4d07da41.svg").toString();